const hotelData = [
  {
    combain_name: "Bodhi Vihar By WB Economy, Patna, Bihar, India",
    hotel_id: 771,
    hotel_name: "Bodhi Vihar By WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name:
      "Ramanand Restaurant & Guest house by WB Economy, Ayodhya, Uttar Pradesh, India",
    hotel_id: 491,
    hotel_name: "Ramanand Restaurant & Guest house by WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name: "Bollywood by WB Economy, Bhubaneshwar, Odisha, India",
    hotel_id: 503,
    hotel_name: "Bollywood by WB Economy",
    state_name: "Odisha",
  },
  {
    combain_name: "Kamdhenu Patna By WB Economy, Patna, Bihar, India",
    hotel_id: 948,
    hotel_name: "Kamdhenu Patna By WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Hari OM By WB Economy, Nalanda, Bihar, India",
    hotel_id: 953,
    hotel_name: "Hotel Hari OM By WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Party Zone by WB Economy, Hajipur, Bihar, India",
    hotel_id: 949,
    hotel_name: "Party Zone by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Mehak Palace By WB Inn, Noida, Uttar Pradesh, India",
    hotel_id: 1007,
    hotel_name: "Hotel Mehak Palace By WB Inn",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name: "Hotel Vintage by WB Inn  , New Delhi, Delhi, India",
    hotel_id: 1099,
    hotel_name: "Hotel Vintage by WB Inn  ",
    state_name: "Delhi",
  },
  {
    combain_name: "Hotel Mandala by WB Economy, Gangtok, Sikkim, India",
    hotel_id: 1251,
    hotel_name: "Hotel Mandala by WB Economy",
    state_name: "Sikkim",
  },
  {
    combain_name: "Hotel Sahil By WB Economy,  Jammu , Jammu & Kashmir, India",
    hotel_id: 1312,
    hotel_name: "Hotel Sahil By WB Economy",
    state_name: "Jammu & Kashmir",
  },
  {
    combain_name:
      "Hotel Singh Residency By WB Economy, Varanasi, Uttar Pradesh, India",
    hotel_id: 1322,
    hotel_name: "Hotel Singh Residency By WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name:
      "Hotel Blue Berry and Restaurant By WB Economy, Agra, Uttar Pradesh, India ",
    hotel_id: 1368,
    hotel_name: "Hotel Blue Berry and Restaurant By WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name:
      "Hotel Purvanchal & Restaurant By WB Economy, Jaunpur, Uttar Pradesh, India",
    hotel_id: 1385,
    hotel_name: "Hotel Purvanchal & Restaurant By WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1433,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name:
      "Grand Arsh Residency By WB Economy, Ranchi, Jharkhand, India",
    hotel_id: 1428,
    hotel_name: "Grand Arsh Residency By WB Economy",
    state_name: "Jharkhand",
  },
  {
    combain_name:
      "Wanderlust Resort By WB Economy, Ghatghar, Maharashtra, India",
    hotel_id: 1421,
    hotel_name: "Wanderlust Resort By WB Economy",
    state_name: "Maharashtra",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1434,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1435,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1436,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1438,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1439,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1441,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1443,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1444,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1437,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1440,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Atithi by WB Economy, Deo, Bihar, India ",
    hotel_id: 1442,
    hotel_name: "Hotel Atithi by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name:
      "Hotel Sanjay Royal By WB Economy, Mathura, Uttar Pradesh, India",
    hotel_id: 1461,
    hotel_name: "Hotel Sanjay Royal By WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name: "Hotel City Comfort BY WB Economy, Goa, Goa, India",
    hotel_id: 1449,
    hotel_name: "Hotel City Comfort BY WB Economy",
    state_name: "Goa",
  },
  {
    combain_name: "Hotel City Garden BY WB ECONOMY, Goa, Goa, India",
    hotel_id: 1448,
    hotel_name: "Hotel City Garden BY WB ECONOMY",
    state_name: "Goa",
  },
  {
    combain_name: "Ganpati Palace By WB Economy, Shirdi, Maharashtra, India",
    hotel_id: 1497,
    hotel_name: "Ganpati Palace By WB Economy",
    state_name: "Maharashtra",
  },
  {
    combain_name: "Hotel The D P Inn By Wb Economy, Patna, Bihar, India",
    hotel_id: 1505,
    hotel_name: "Hotel The D P Inn By Wb Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Maharashtra By WB Economy, Miraj, Maharashtra, India",
    hotel_id: 1504,
    hotel_name: "Hotel Maharashtra By WB Economy",
    state_name: "Maharashtra",
  },
  {
    combain_name: "Hotel Emperio by WB Economy, Lucknow, Uttar Pradesh, India",
    hotel_id: 1506,
    hotel_name: "Hotel Emperio by WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name: "Hotel Petals Inn by WB Economy, Patna, Bihar, India",
    hotel_id: 1507,
    hotel_name: "Hotel Petals Inn by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Hotel Sun Rose by WB Economy, Boisar, Maharashtra, India",
    hotel_id: 1533,
    hotel_name: "Hotel Sun Rose by WB Economy",
    state_name: "Maharashtra",
  },
  {
    combain_name:
      "Hotel J R Place & Restaurant by WB Economy, Agra, Uttar Pradesh, India",
    hotel_id: 1551,
    hotel_name: "Hotel J R Place & Restaurant by WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name:
      "Hotel Bodhi Inn by WB Economy,  Lucknow, Uttar Pradesh, India",
    hotel_id: 1674,
    hotel_name: "Hotel Bodhi Inn by WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name:
      "Hotel Bhavya Inn & Restaurant by WB Economy, Mathura, Uttar Pradesh, India",
    hotel_id: 1676,
    hotel_name: "Hotel Bhavya Inn & Restaurant by WB Economy",
    state_name: "Uttar Pradesh",
  },
  {
    combain_name:
      "Snow Tiger Resort by WB Economy, Shivpuri, Uttarakhand, India",
    hotel_id: 1671,
    hotel_name: "Snow Tiger Resort by WB Economy",
    state_name: "Uttarakhand",
  },
  {
    combain_name: "Buddha Residency By WB Economy, Patna, Bihar, India",
    hotel_id: 1236,
    hotel_name: "Buddha Residency By WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Arti Hotel  BY WB Economy, Hajipur, Bihar, India",
    hotel_id: 1330,
    hotel_name: "Arti Hotel  BY WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "New Shivani Inn By WB Economy, Patna, Bihar, India",
    hotel_id: 950,
    hotel_name: "New Shivani Inn By WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Picnic Plaza by WB Economy, Goa, Goa, India",
    hotel_id: 916,
    hotel_name: "Picnic Plaza by WB Economy",
    state_name: "Goa",
  },
  {
    combain_name:
      "SVR Hotel & Banquet Patna by WB Economy, Patna, Bihar, India",
    hotel_id: 802,
    hotel_name: "SVR Hotel & Banquet Patna by WB Economy",
    state_name: "Bihar",
  },
  {
    combain_name: "Aditi Vadodara By WB Economy, Vadodara, Gujarat, India",
    hotel_id: 799,
    hotel_name: "Aditi Vadodara By WB Economy",
    state_name: "Gujarat",
  },
  {
    combain_name: "Hotel M S Bhagalpur By WB Economy, Bhagalpur, Bihar, India",
    hotel_id: 1116,
    hotel_name: "Hotel M S Bhagalpur By WB Economy",
    state_name: "Bihar",
  },
];

function uniqByKeepLast(data, key) {
  return [...new Map(data.map((x) => [key(x), x])).values()];
}

export const hotelFiltered = uniqByKeepLast(hotelData, (it) => it.combain_name)
